<template>
  <b-row>
    <b-col md="6" v-if="showSearch">
      <b-form inline @submit.prevent="startSearch">
        <b-form-input v-model="searchString" placeholder="Search" class="mx-1"></b-form-input>
        <b-form-select v-model="typeFilterVal" :options="typeFilterOptions" placeholder="Filter by type" class="mx-1">
        </b-form-select>
        <b-button @click="startSearch" variant="primary" class="m-1">Search</b-button>
        <b-button @click="clearSearch" variant="danger" class="m-1">Clear Search</b-button>
      </b-form>
    </b-col>
    <b-col md="6">
      <b-pagination v-model="currentPage" :per-page="itemsPerPage" :limit="5" :total-rows="totalItems"
        @change="pageChanged" :disabled="dataLoading" align="fill" class="mt-1">
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '@/modules/staticData';

let intervalRef = null;

export default {
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: -1,
      items: [],
      searchString: '',
      fixedSearchString: '',
      typeFilterOptions: [
        { value: null, text: 'All' },
        { value: 0, text: 'Android' },
        { value: 1, text: 'WEB' },
      ],
      typeFilterVal: null,
      fixedTypeFilterVal: null,
      dataLoading: false,
    };
  },
  props: {
    apiUrl: {
      type: [String],
      required: true,
    },
    startingPage: {
      type: [Number],
      required: false,
    },
    perPage: {
      type: [Number],
      required: false,
    },
    showSearch: {
      type: [Boolean],
      required: false,
    },
    queryStructure: {
      type: [Object],
      required: true,
    },
    pollingInterval: {
      type: [Number],
      required: false,
      default: 0,
    },

  },
  created() {
    if (this.startingPage) {
      this.currentPage = this.startingPage;
    }
    if (this.perPage) {
      this.itemsPerPage = this.perPage;
    }
    this.pageChanged();
  },
  beforeDestroy() {
    this.resetPollingInterval();
  },
  methods: {
    // fetches the data retuns the promise
    fetchData(newPage) {
      // generate params
      const params = {
        [this.queryStructure.pagePropName]: newPage,
        [this.queryStructure.perPagePropName]: this.itemsPerPage,
        [this.queryStructure.searchPropName]: this.fixedSearchString,
        [this.queryStructure.typeFilterPropName]: this.fixedTypeFilterVal,
      };
      // custom keys and values
      if (this.queryStructure.custom && Object.keys(this.queryStructure).length > 0) {
        Object.keys(this.queryStructure.custom).forEach((k) => {
          params[k] = this.queryStructure.custom[k];
        });
      }
      // fetch the data
      const deferred = new Promise((resolve, reject) => {
        const axiosPromise = axios.get(apiUrlPrefix + this.apiUrl, { params });
        axiosPromise.then((r) => { resolve(r.data); });
        axiosPromise.catch(() => { reject(); });
      });
      return deferred;
    },
    // updates the data
    pageChanged(np) {
      const newPage = np || this.currentPage;
      this.dataLoading = true;
      this.$emit('items-updated', null);
      this.resetPollingInterval();
      this.fetchData(newPage).then((data) => {
        const responseData = data[this.queryStructure.responseDataKey];
        this.items = responseData.data;
        this.totalItems = responseData.total;
        this.setPollingInterval();
        // check edge case when last item on last page and cover an edge case when there's 0 items
        const maxPage = Math.ceil(this.totalItems / this.itemsPerPage) || 1;
        if (maxPage < this.currentPage) {
          this.currentPage = maxPage;
          this.pageChanged();
        }
        this.$emit('items-updated', this.items);
      }, () => {
      }).finally(() => {
        this.dataLoading = false;
      });
    },
    startSearch() {
      this.fixedSearchString = this.searchString;
      this.fixedTypeFilterVal = this.typeFilterVal;
      this.currentPage = 1;
      this.pageChanged();
    },
    clearSearch() {
      this.fixedSearchString = '';
      this.searchString = '';
      this.fixedTypeFilterVal = null;
      this.typeFilterVal = null;
      this.currentPage = 1;
      this.pageChanged(1);
    },
    resetPollingInterval() {
      if (intervalRef) {
        window.clearInterval(intervalRef);
        intervalRef = null;
      }
    },
    setPollingInterval() {
      if (this.pollingInterval > 0) {
        intervalRef = window.setInterval(() => {
          this.pageChanged();
        }, this.pollingInterval * 1000);
      }
    },
  },
};
</script>
